
import { Cell, CellGroup, ImagePreview } from 'vant'
import { jsSdk } from '../../../assets/libs/loadjs';

export default {
  name: 'home',
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
  },
  data () {
    return {
      // 是否支持导航
      isNavigate: false,
      // 公众号
      nowImei: $cookies.get('imei'),
      // 分享标题
      shareTitle: '',
      // 分享描述
      descText: '',
      // 分享图标
      shareIcon: require('../../../assets/images/map/ic_redcar.png'),
      // 目的页面名称
      pageName: '',
      // 权限开放
      accessToken: '',
      expiresTime: ''
    }
  },
  methods: {
    // 获取accessToken
    initGetAccessTokenFn () {
      let _this = this;
      this.$toast.loading({
        mask: true,
        duration: 0,
        message: '加载中...'
      });
      this.$axios.post('/oauth/getAccessToken', {apis: ['refresh']})
        .then(function (response) {
          // console.log(response);
          // 关闭加载状态
          _this.$toast.clear();
          if (response.data.ret === 0) {
            _this.accessToken = response.data.data.accessToken;
            _this.expiresTime = response.data.data.expiresIn;
            _this.shareSetFn();
          } else {
            _this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '获取Token失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          _this.$toast.clear();
          errorModal(error, 561);
        })
    },
    // 自定义分享
    shareSetFn () {
      let _this = this;
      // 分享描述
      let descText = this.descText;
      // 链接域名
      let baseLink = window.location.origin;
      // 分享链接
      // let shareLink = baseLink + '/' + this.pageName + '?imei=' + _this.nowImei + '&time=' + (new Date()).valueOf();
      let shareLink = baseLink + '/' + this.pageName + '?imei=' + _this.nowImei + '&time=' + _this.expiresTime + '&token=' + _this.accessToken;
      // 分享图标
      // let shareImgUrl = 'http://wx-server-dev.spreadwin.cn/ysn/img/ic_logo_w.png';
      let shareImgUrl = this.shareIcon;
      // jsSdk(this.$store.state.customer, ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline']).then(function(wx){
      // 传第三个参数可以解决vue内部IOS系统失败的问题
      // jsSdk(this.$store.state.customer, ['updateAppMessageShareData', 'updateTimelineShareData'], window.location.origin + '/').then(function(wx){
      // 采用方法,如果调用失败自动刷新一次
      jsSdk(this.$store.state.customer, ['updateAppMessageShareData', 'updateTimelineShareData']).then(function(wx){
        // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容(安卓可以设置成功,IOS设置会失败)
        wx.updateAppMessageShareData({
          title: _this.shareTitle || document.title, // 分享标题
          desc: descText, // 分享描述
          link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: shareImgUrl, // 分享图标
          success: function () {
            // 设置成功
            console.log('share - 设置成功111 - share');
          },
          fail:function(res){
            console.log('share - fail:' + JSON.stringify(res));
            if( /offline/i.test(res.errMsg) ){
              // ios报错:the permission value is offline verifying
              // ios报错:updateAppMessageShareData:the permission value is offline verifying
              // ios报错原因：ISO上微信只识别了主页地址，而不是当前页面地址(与vue的push跳转有关).解决方法：刷新一次(必须多加一个参数才有效,如&xj=xj)
              // let nowLink =  window.location.origin + '/share?scene=pickup&xj=xj';
              // window.location.replace(nowLink);
            }
          }
        });
        // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容(安卓可以设置成功,IOS设置会失败)
        wx.updateTimelineShareData({
          title: _this.shareTitle || document.title, // 分享标题
          link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: shareImgUrl, // 分享图标
          success: function () {
            // 设置成功
            console.log('share - 设置成功222');
          },
          fail:function(res){
            console.log('share - fail-two:' + JSON.stringify(res));
            if( /offline/i.test(res.errMsg) ){
              // ios报错:the permission value is offline verifying
              // ios报错:updateAppMessageShareData:the permission value is offline verifying
              // let nowLink =  window.location.origin + '/share?scene=pickup&xj=xj';
              // window.location.replace(nowLink);
            }
          }
        });
        // 获取“分享给朋友”按钮点击状态及自定义分享内容接口（即将废弃）(兼容IOS)
        // wx.onMenuShareAppMessage({
        //   title: _this.shareTitle || document.title,
        //   desc: descText,
        //   link: shareLink,
        //   imgUrl: shareImgUrl,
        //   type: '',
        //   dataUrl: '',
        //   success: function () {
        //     // 用户点击了分享后执行的回调函数
        //     console.log('share - 分享成功111');
        //   }
        // });
        // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口（即将废弃）(兼容IOS)
        // wx.onMenuShareTimeline({
        //   title: _this.shareTitle || document.title,
        //   link: shareLink,
        //   imgUrl: shareImgUrl,
        //   success: function () {
        //     // 用户点击了分享后执行的回调函数
        //     console.log('share - 分享成功222');
        //   }
        // });
      });
    }
  },
  mounted () {
    // 获取页面传参(分享场景)
    let shareScene = this.$route.query.scene;
    if (shareScene === 'pickup') {
      // 接人服务
      // 判断该设备是否具有接人服务功能
      if (!this.$cookies.get('navAbility').pickUp) {
        let _this = this;
        this.$dialog({
          message: '该设备不支持接人服务'
        }).then(() => {
          _this.$router.go(-1);
        });
        return;
      }
      this.initGetAccessTokenFn();
      this.isNavigate = true;
      this.shareTitle = '让我来接你';
      this.descText = '我来接你了，点击这里，告诉我你在哪里，同时你还可以看到我的位置。';
      this.pageName = 'pickupServer';
    } else if (shareScene === 'guiding') {
      // 好友指路
      // 判断该设备是否具有好友指路功能
      if (!this.$cookies.get('navAbility').friendDirect) {
        let _this = this;
        this.$dialog({
          message: '该设备不支持好友指路'
        }).then(() => {
          _this.$router.go(-1);
        });
        return;
      }
      this.initGetAccessTokenFn();
      this.isNavigate = true;
      this.shareTitle = '帮我指下路';
      this.descText = '谢谢';
      this.pageName = 'guidingWay';
    } else {
      this.$notify({
        message: '参数错误',
        duration: 0,
        background: '#ff3300'
      })
    }
    // this.$nextTick(this.shareSetFn);
    // this.shareSetFn();
  },
  destroyed () {
    this.$notify.clear();
  }
}
